import HeadBlock from '$/components/global/heading';
import HeadingTab from '$/components/global/headingTab';

interface IDataSitesNavigationProps {
  children: React.ReactNode;
}

const DataSitesNavigation: React.FC<IDataSitesNavigationProps> = ({ children }) => {
  const baseUrl = `/data-sites`;
  const accessUrl = `${baseUrl}/access`;
  const removalsUrl = `${baseUrl}/removals`;

  return (
    <>
      <HeadBlock title="Data Sites">
        <HeadingTab title="Current Access" link={accessUrl} exact={true} />
        <HeadingTab title="Removals" link={removalsUrl} exact={true} />
      </HeadBlock>
      <div>{children}</div>
    </>
  );
};

export default DataSitesNavigation;
